<template>
  <div>
    <a-drawer :width="880" :closable="false" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="close">
      <a-skeleton v-if="loading" active />
      <div v-else>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-descriptions size="small">
              <span slot="title">
                <span>{{ caseData.name }}</span>
                <span class="description_subtitle">#{{ caseData.key }}</span>
              </span>
            </a-descriptions>
          </a-col>
        </a-row>
        <a-divider orientation="left"><span style="font-size: 14px; font-weight: normal">用例详情</span></a-divider>
        <div class="case-detail">
          <a-descriptions :column="2" size="small">
            <a-descriptions-item label="优先级">
              <a-tag v-if="![undefined, null].includes(caseData.priority)" :color="casePrioritys[caseData.priority].color"> {{ casePrioritys[caseData.priority].label }} </a-tag>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="状态">
              <a-tag v-if="caseData.status" :color="caseStatus[caseData.status].color">
                {{ caseStatus[caseData.status].label }}
              </a-tag>
              <span v-else>--</span>
            </a-descriptions-item>
            <a-descriptions-item label="创建人">{{ caseData.creator ? caseData.creator.nickname : '--' }} </a-descriptions-item>
            <a-descriptions-item label="最后修改人">{{ caseData.modifier ? caseData.modifier.nickname : '--' }} </a-descriptions-item>
            <a-descriptions-item label="创建时间">{{ caseData.created_time }}</a-descriptions-item>
            <a-descriptions-item label="更新时间"> {{ caseData.updated_time }}</a-descriptions-item>
            <a-descriptions-item label="标签" :span="2">
              <a-tag v-for="(tag, index) in caseData.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
            </a-descriptions-item>
          </a-descriptions>
          <a-tabs size="small">
            <a-tab-pane key="1" tab="详细信息">
              <a-descriptions layout="vertical" :column="2">
                <a-descriptions-item label="前置条件" :span="2">
                  <span>{{ caseData.precondition }}</span>
                </a-descriptions-item>
                <a-descriptions-item label="操作步骤" :span="2">
                  <a-table class="steps_table" size="small" :pagination="false" :columns="columns" :data-source="caseData.steps" :row-key="(_, index) => index" />
                </a-descriptions-item>
                <a-descriptions-item label="备注" :span="2">
                  <vditor-preview :content="caseData.description === null ? '' : caseData.description" />
                </a-descriptions-item>
              </a-descriptions>
            </a-tab-pane>
            <a-tab-pane key="2" tab="关联需求">
              <case-requirement :data-source="caseData.requirements" :case-id="caseId" @reload="getCaseDetail" />
              <case-requirement-relation :data-source="caseData.requirements" :case-id="caseId" @reload="getCaseDetail" />
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <div style="padding-top: 2px">
        <a-divider orientation="left"><span style="font-size: 14px; font-weight: normal">用例评审</span></a-divider>
        <a-descriptions :column="3" size="small">
          <a-descriptions-item label="评审结果(上次)">
            <review-case-result-edit :disabled="true" :review-id="reviewId" :case-id="caseData.id" :result="caseData.result" />
          </a-descriptions-item>
          <a-descriptions-item label="评审时间(上次)">
            <span v-if="caseData.result !== 1">{{ caseData.reviewTime }}</span>
            <span v-else>--</span>
          </a-descriptions-item>
          <a-descriptions-item label="评审人员(上次)">
            <span v-if="caseData.result !== 1">{{ caseData.reviewer ? caseData.reviewer.nickname : '--' }}</span>
            <span v-else>--</span>
          </a-descriptions-item>
        </a-descriptions>
        <a-textarea v-model="resultComment" placeholder="评审结果备注" :auto-size="{ minRows: 3, maxRows: 3 }" />
      </div>
      <div style="position: absolute; right: 25px; bottom: 25px">
        <a-button type="dashed" :size="size" :disabled="!hasBefore" style="margin-right: 10px" @click="onBeforeCase">
          <a-icon type="left" />
          上一条
        </a-button>
        <a-button type="dashed" :size="size" :disabled="!hasNext" style="margin-right: 10px" @click="onNextCase">
          下一条
          <a-icon type="right" />
        </a-button>
        <a-tooltip>
          <template slot="title"> 评审结果置为"已评审"并加载下一条 </template>
          <a-button class="pass-btn" :size="size" @click="onCaseReviewed"> 已评审 </a-button>
        </a-tooltip>
        <a-tooltip>
          <template slot="title"> 评审结果置为"待更新"并加载下一条 </template>
          <a-button class="fail-btn" :size="size" @click="onCaseNeedUpdate"> 待更新 </a-button>
        </a-tooltip>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { tagList } from '@/api/system/tag';
import { caseUpdate, moduleList } from '@/api/project/case';
import VditorPreview from '@/components/VditorEditor/preview';
import { casePrioritys, caseStatus } from '@/utils/dictionary';
import CaseRequirement from '@/pages/project/case/components/CaseRequirement';
import { reviewCaseDetail, updateReviewItemResult } from '@/api/project/review';
import ReviewCaseResultEdit from '@/pages/project/review/components/ReviewCaseResultEdit';
import CaseRequirementRelation from '@/pages/project/case/components/CaseRequirementRelation';

const columns = [
  {
    title: '序号',
    dataIndex: 'number',
    key: 'number',
    align: 'center',
    width: 60,
    customRender: (_text, _row, index) => {
      return index + 1;
    }
  },
  {
    title: '操作步骤',
    dataIndex: 'step',
    key: 'step'
  },
  {
    title: '预期结果',
    dataIndex: 'result',
    key: 'result'
  }
];
export default {
  components: { VditorPreview, CaseRequirement, CaseRequirementRelation, ReviewCaseResultEdit },
  props: {
    display: {
      type: Boolean,
      default: false
    },
    reviewId: {
      type: [Number, String],
      default: null
    },
    caseId: {
      type: [Number, String],
      default: null
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    hasBefore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns,
      caseStatus,
      casePrioritys,
      loading: true,
      visible: false,
      caseData: {},
      projectId: parseInt(this.$route.params.project_id) || null,
      size: 'small',
      resultComment: '',
      autoLoadNextCase: false,
      moduleData: [],
      form: {
        steps: []
      },
      rules: {
        name: [{ required: true, message: '用例名称不能为空', trigger: 'blur' }],
        priority: [{ required: true, message: '优先级不能为空', trigger: 'blur' }],
        module_id: [{ required: true, message: '所属目录不能为空', trigger: 'blur' }],
        precondition: [{ required: true, message: '前置条件不能为空', trigger: 'blur' }]
      },
      modalVisible: false,
      issueId: null
    };
  },
  watch: {
    display() {
      this.visible = this.display;
      if (this.visible === true) {
        this.getTagList();
        this.getModuleList();
        if (this.caseId !== null) {
          this.getCaseDetail();
        }
      }
    },
    caseId() {
      if (this.caseId !== null) {
        this.getCaseDetail();
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.caseId) {
            caseUpdate({ ...this.form, project_id: this.projectId, id: this.caseId })
              .then(() => {
                this.$message.success('用例修改成功');
                this.getCaseDetail();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    getTagList() {
      tagList({ group_code: 'case' }).then(res => {
        this.tagData = res.data.items;
      });
    },
    // 获取模块列表
    getModuleList() {
      moduleList({ project_id: this.projectId, return_type: 'tree' }).then(res => {
        this.moduleData = res.data.items;
      });
    },
    deleteStep(index) {
      this.form.steps.splice(index, 1);
    },

    onAddStep() {
      this.form.steps.push({ step: null, result: null });
    },

    // 数据变更的回调
    onChange(target) {
      this.$refs.form.validateField([target]);
    },
    autoLoadNextCaseChange(e) {
      this.autoLoadNextCase = e.target.checked;
    },
    // 获取用例详情
    getCaseDetail() {
      reviewCaseDetail({ project_id: this.projectId, review_id: this.reviewId, case_id: this.caseId })
        .then(res => {
          this.caseData = res.data;
          this.resultComment = res.data.resultComment;
          this.form = {
            name: this.caseData.name,
            priority: this.caseData.priority,
            module_id: this.caseData.module_id,
            precondition: this.caseData.precondition,
            description: this.caseData.description ? this.caseData.description : '',
            steps: this.caseData.steps.length > 0 ? this.caseData.steps : [{ step: null, result: null }],
            tags: this.caseData.tags.map(item => {
              return item.id;
            })
          };
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit('close');
    },
    onAddIssue() {
      this.modalVisible = true;
      this.issueId = null;
    },
    closeIssueModal() {
      this.$message.success('创建缺陷成功!');
      this.modalVisible = false;
    },
    onCaseReviewed() {
      this.updateReviewCaseResult(3, this.resultComment);
    },
    onCaseNeedUpdate() {
      this.updateReviewCaseResult(4, this.resultComment);
    },
    onNextCase() {
      this.$emit('next');
    },
    onBeforeCase() {
      this.$emit('before');
    },
    updateReviewCaseResult(result, description) {
      updateReviewItemResult({
        review_id: this.reviewId,
        result: result,
        item_id: this.caseId,
        description: description
      }).then(() => {
        this.$message.success('结果更新成功');
        this.$emit('next');
        // this.$emit('change');
        // if (this.autoLoadNextCase) {
        //   this.$emit('next')
        // } else {
        //   this.getCaseDetail()
        // }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.case-detail {
  overflow-y: auto;
  height: calc(~'100vh - 350px');
}

/deep/ .ant-descriptions-title {
  margin-bottom: 0px;
}

.description_subtitle {
  margin-left: 8px;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

/deep/ .drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

/deep/ .ant-form-item {
  margin-bottom: 8px;
}

/deep/ .steps_table .ant-input {
  resize: none;
  border: none;
  border-radius: 0;
  background-color: transparent;
  margin: 2px 0;
  // border-bottom: 1px solid #d9d9d9;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:focus {
  border: none;
  border-bottom: 1px solid #1890ff;
  box-shadow: none;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:hover {
  border-bottom: 1px solid #1890ff;
}

/deep/ .ant-table-tbody > tr > td {
  padding: 0;
}

.steps_table {
  margin-bottom: 4px;
}

.pass-btn {
  color: #fff;
  background-color: #87d068;
  border-color: #87d068;
  margin-right: 10px;
}

.fail-btn {
  color: #fff;
  background-color: #e95409;
  border-color: #e95409;
  margin-right: 10px;
}

.block-btn {
  color: #fff;
  background-color: #bab8b7;
  border-color: #bab8b7;
  margin-right: 10px;
}

.na-btn {
  color: #fff;
  background-color: #b24610;
  border-color: #b24610;
  margin-right: 10px;
}
</style>
